import Vue from "vue";
import Vuex from "vuex";
import apirequests from "../include/indexeddb/stores/apirequests";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		showMenu: true,
		modalSettings: {
			type: null,
			title: null,
			selectCallBack: function () {},
			selected: [],
			data: [],
			captionKey: null,
			newBtn: false,
			newCallback: function () {},
			placeholder: null,
		},
		dialogSettings: {
			show: false,
			title: null,
			content: null,
			htmlContent: null,
			confirmBtn: true,
			cancelBtn: false,
			size: null, // sm, lg, xl
			confirmCallBack: function () {},
			cancelCallBack: function () {},
			prompt: null,
			multilinePrompt: false,
			defaultUserInput: null,
			cypressId: null,
		},
		notifications: [],
		latestNotification: 0,
		treatmentSessionComments: {
			unreadCount: 0,
			showModal: false,
		},
		treatmentSessionSelectCompetencyTests: {
			showModal: false,
		},
		treatmentSessionCompetencyTestMarking: {
			showModal: false,
			test: null,
		},
		csv: [],
		showBlockingSpinner: false,
		loggedIn: false,
		externaluser: false,
	},
	actions: {
		// use actions/store.dispatch instead of mutations/store.commit for any asynchronous operations
		// the actions should then call store.commit in turn
		// see https://hackernoon.com/correct-and-efficient-way-to-use-vuex-part-i-wf15432eu
		async clearApiRequests() {
			await apirequests.clear();
		}
	},
	mutations: {
		// ---------- Modals ----------
		openModal(state, modalSettings) {
			state.modalSettings = modalSettings;
		},
		closeModal(state) {
			state.modalSettings.type = null;
		},
		// ---------- ---------- ----------

		// ---------- Dialogs ----------
		openDialog(state, dialogSettings) {
			// alternative signature for simple alerts
			state.dialogSettings = {
				show: false,
				title: null,
				content: null,
				htmlContent: null,
				confirmBtn: true,
				cancelBtn: false,
				size: null, // sm, lg, xl
				confirmCallBack: function () {},
				cancelCallBack: function () {},
				prompt: null,
				multilinePrompt: false,
				defaultUserInput: null,
				cypressId: null,
			};
			if (typeof dialogSettings === "object") {
				state.dialogSettings = {
					...state.dialogSettings,
					...dialogSettings
				}
			}
			if (typeof dialogSettings === "string") {
				state.dialogSettings.content = dialogSettings
			}
			state.dialogSettings.show = true;
			if (dialogSettings.prompt) {
				this._vm.$nextTick(function () {
					document.getElementById("dialog-prompt").focus();
				});
			}
		},
		closeDialog(state) {
			state.dialogSettings.show = false;
		},
		// ---------- ---------- ----------

		// ---------- Messages ----------
		setNotifications(state, notifications) {
			state.notifications = notifications;
			// Set the latest to the last one in the array
			if (notifications.length > 0) {
				//state.latestNotification = notifications[notifications.length - 1];
				//state.latestNotification = { ...notifications[notifications.length - 1], timestamp: Date.now() };
				state.latestNotification = Date.now();
			}
		},
		addNotification(state, notification) {
		  	state.notifications.push(notification);
		  	//state.latestNotification = notification;
		  	state.latestNotification = Date.now();
		},
		addNotifications(state, notifications) {
			state.notifications.push(...notifications);
			// Set the latest to the last one in the array
			if (notifications.length > 0) {
				//state.latestNotification = notifications[notifications.length - 1];
				state.latestNotification = Date.now();
			}
		},
		clearNotification(state, notificationId) {
		  	state.notifications = state.notifications.filter(n => n.id !== notificationId);
		},    
		clearAllNotifications(state) {
			state.notifications = [];
		},

		// ---------- Blocking Spinner ----------
		showBlockingSpinner(state) {
			state.showBlockingSpinner = true;
		},
		hideBlockingSpinner(state) {
			state.showBlockingSpinner = false;
		},
		// ---------- ---------- ----------

		// ---------- Log in/out ----------
		logIn(state) {
			this._vm.$users.refresh.call(this._vm);
			state.loggedIn = true;
		},

		logOut(state) {
			this._vm.$UserSession.clearUserData.call(this._vm);
			this._vm.$users.clearData.call(this._vm);
			state.loggedIn = false;
		},
		// ---------- ---------- ----------
		//------------ CSV ---------------
		setCSV(state, csv) {
			state.csv = csv;
		},
		// ---------- ---------- ----------
		//------------ Ext User ---------------
		setExtUser(state,status) {
			state.externaluser = status;
		}
		// ---------- ---------- ----------
	},
	getters: {
    	unreadNotifications: state => state.notifications.filter(n => !n.read),
    	notificationCount: state => state.notifications.length,
		getCSV(state) {
			return state.csv;
		},
		isUserLoggedIn(state){
			return state;
		}
	  }
});

export default store;
